const data = [
  {
    img: [
      "images/cars/a4-w9.jpg",
      "images/cars/a4-w12.jpg",
      "images/cars/a4-w4.jpg",
      "images/cars/a4-w5.jpg",
      "images/cars/a4-w7.jpg",
      "images/cars/a4-w8.jpg",
      "images/cars/a4-w3.jpg",
      "images/cars/a4-w10.jpg",
      "images/cars/a4-w11.jpg",
      "images/cars/a4-w6.jpg",
    ],
    title: "AUDI A4 (WITH SUNROOF) White",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 10000, month: 95000, wd: 8000 },
  },
  {
    img: ["images/cars/a4-w1.jpg", "images/cars/a4-w2.jpg"],
    title: "AUDI A4 (Without sun roof)",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 9000, month: 85000, wd: 7000 },
  },
  {
    img: [
      "images/cars/al-w3.jpg",
      "images/cars/al-w1.jpg",
      "images/cars/al-w2.jpg",
      "images/cars/al-w4.jpg",
    ],
    title: "ALTO 800",
    transmission: "Manual",
    fuel: "Petrol",
    price: { day: 1000, month: 11000 },
  },
  {
    img: [
      "images/cars/bm3.jpg",
      "images/cars/bm5.jpg",
      "images/cars/bm4.jpg",
      "images/cars/bm6.jpg",
      "images/cars/bm8.jpg",

    ],
    title: "bmw 5 series",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 13000, month: "1.20L", wd: 10000 },
  },
  {
    img: ["images/cars/bm-w1.jpg"],
    title: "bmw 5 series white",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 13000, month: "1.20L", wd: 10000 },
  },
  {
    img: ["images/cars/bze1.jpg"],
    title: "Mercedez Benz E class",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 13000, month: "1.30L", wd: 10000 },
  },
  {
    img: ["images/cars/bzl-1.jpg"],
    title: "Mercedes Benz W124 (Left Hand)",
    transmission: "Manual",
    fuel: "Diesel",
    price: { wd: 8000 },
  },
  {
    img: [
      "images/cars/fr-n1.jpg",
      "images/cars/fr-n2.jpg",
      "images/cars/fr-n3.jpg",
      "images/cars/fr-n4.jpg",
    ],
    title: "Toyota Fortuner New",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { day: 8000, month: 95000 },
  },
  {
    img: [
      "images/cars/fr-o1.jpg",
      "images/cars/fr-o2.jpg",
      "images/cars/fr-o3.jpg",
      "images/cars/fr-o4.jpg",
      "images/cars/fr-o5.jpg",
      "images/cars/fr-o6.jpg",
      "images/cars/fr-o7.jpg",
    ],
    title: "Toyota Fortuner Old",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 4000, month: 55000 },
  },
  {
    img: ["images/cars/gz1.jpg", "images/cars/gz2.jpg"],
    title: "Toyota Glanza",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { day: 1500, month: 25000 },
  },
  {
    img: [
      "images/cars/in1.jpg",
      "images/cars/in2.jpg",
      "images/cars/in3.jpg",
      "images/cars/in4.jpg",
    ],
    title: "Toyota Innova",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 2000, month: 33000 },
  },
  {
    img: ["images/cars/jg1.jpg"],
    title: "Jaguar xf",
    transmission: "Automatic",
    fuel: "Diesel",
    price: { wd: 14000 },
  },
  {
    img: [
      "images/cars/m5.jpg",
      "images/cars/m6.jpg",
    ],
    title: "Mini Cooper Covertible",
    transmission: "Manual",
    fuel: "Petrol",
    price: { day: 16000, month: "1.35L", wd: 13000 },
  },

  {
    img: ["images/cars/sw-bl-2.jpg", "images/cars/sw-r-1.jpg", "images/cars/sw-bl-1.jpg", "images/cars/sw-1.jpg", "images/cars/sw-3.jpg", "images/cars/sw-4.jpg", "images/cars/sw-2.jpg"],
    title: "Swift New",
    transmission: "Automatic",
    fuel: "Petrol",
    price: { day: 1800, month: 25000 },
  },
  {
    img: [
      "images/cars/thar1.jpg",
      "images/cars/thar2.jpg",
      "images/cars/thar3.jpg",
      "images/cars/thar4.jpg",
      "images/cars/thar5.jpg",
    ],
    title: "Thar",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 5000, month: 70000 },
  },
  {
    img: ["images/cars/cr-1.jpg", "images/cars/cr-2.jpg"],
    title: "Hyundai Creta",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 2000, month: 33000 },
  },
  {
    img: [
      "images/cars/mc-1.jpg",
      "images/cars/mc-2.jpg",
      "images/cars/mc-3.jpg",
    ],
    title: "Nissan Micra",
    transmission: "Manual",
    fuel: "Diesel",
    price: { day: 1500, month: 16000 },
  },
];

export default data;